import {
  CRMConversationAutoReplyStatus,
  CRMConversationAutoResponseStatus,
} from "../../types";

export enum TwilioMessageType {
  text = "text",
}

type TwilioMessagePayload = {
  text: string;
  timestamp: string;
  type: TwilioMessageType;
};

export type TwilioMessageModel = {
  id: string;
  conv_id: string;
  name: string;
  type: "outgoing" | "incoming" | "info";
  msg_type: TwilioMessageType;
  from: string;
  msg_id: string;
  payload: TwilioMessagePayload;
  entity_id: string;
  read: boolean;
  status: string | null;
  attended_by?: string;
  auto_response: CRMConversationAutoResponseStatus;
  auto_reply: CRMConversationAutoReplyStatus | null;
  /** @see TwilioMessageDto.sent — `undefined` means unknown, never "failed". */
  sent?: boolean;
};

// DTO type from API (before transformation)
export type TwilioMessageDto = {
  id: string;
  conv_id: string;
  type: "outgoing" | "incoming" | "info";
  msg_type: TwilioMessageType;
  inserted_at: string;
  from: string;
  msg_id: string;
  payload: string;
  entity_id: string;
  read: boolean;
  status: string | null;
  auto_response: number;
  attended_by: string;
  auto_reply: CRMConversationAutoReplyStatus | null;
  /**
   * Twilio delivery flag for outgoing messages. Only an explicit `false` means
   * the provider never sent the message. The field is absent on rows written
   * before it shipped, and may be absent from `twilio_message` socket payloads
   * (which are cast to this type without validation), so consumers must compare
   * `=== false` and treat `undefined` as "unknown, render normally".
   */
  sent?: boolean;
};

export const transformTwilioMessageDtoToModel = (
  dto: TwilioMessageDto
): TwilioMessageModel => {
  return {
    ...dto,
    name: dto.conv_id,
    payload: {
      text: dto.payload,
      timestamp: dto.inserted_at,
      type: dto.msg_type,
    },
  };
};
